import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

/* Utilities */
import { trans } from '~/utilities';

/* Constants */
import { slideFadeInOut } from '~/constants/animations'

/* Common */
import { Button } from '~/components/common';

export default function SearchResults({ results, resultsUrl = '' }) {
    const { vehicles, pages, actions, news } = results || {};
    const totalResults = vehicles?.count || 0 + pages?.count || 0 + actions?.count || 0 + news?.count || 0;

    return (
        <AnimatePresence initial={false} exitBeforeEnter>
            {totalResults > 0 && (
                <motion.div key="results" className="search__overlay-results" {...slideFadeInOut}>
                    <div className="row gutters-3 mb-6">
                        <AnimatePresence initial={false} exitBeforeEnter>
                            {vehicles?.count > 0 && (
                                <motion.div key="vehicles" className="col-12 col--result" {...slideFadeInOut}>
                                    <div className="d-flex justify-content-between mb-2">
                                        <p className="text--16 font-weight-medium mb-0">{trans('app.header.search.vehicles')}</p>
                                        <a className="text--14 text-muted--60 text-base" href={resultsUrl} title={trans('app.header.search.show_amount_results', { amount: vehicles?.count })}>
                                            {trans('app.header.search.show_amount_results', { amount: vehicles?.count })}
                                        </a>
                                    </div>
                                    <div className="row gutters-2">
                                        <AnimatePresence initial={false} exitBeforeEnter>
                                            {vehicles?.items?.map((vehicle, vehicleIndex) => (
                                                <motion.div key={vehicle?.id || vehicleIndex} className="col-12" {...slideFadeInOut}>
                                                    <a href={vehicle?.url} className="d-flex align-items-center text-decoration-none text--14 text-base">
                                                        {vehicle?.images?.length > 0 ?
                                                            (
                                                                <img className="border-radius-1 mr-4" src={vehicle?.images?.[0]?.path} alt={`${vehicle?.brand} ${vehicle?.model} ${vehicle?.type}`} width="75" height="50" />
                                                            )
                                                            :
                                                            (
                                                                <div className="border-radius-1 bg-light mr-4" style={{ width: '75px', height: '50px' }}></div>
                                                            )
                                                        }
                                                        <div className="text-truncate">
                                                            <p className="mb-0 text-truncate">{vehicle?.brand} {vehicle?.model}</p>
                                                            <p className="text-muted--40 text-truncate">{vehicle?.type}</p>
                                                        </div>
                                                    </a>
                                                </motion.div>
                                            ))}
                                        </AnimatePresence>
                                    </div>
                                </motion.div>
                            )}
                        </AnimatePresence>
                        <AnimatePresence initial={false} exitBeforeEnter>
                            {pages?.count > 0 && (
                                <motion.div key="pages" className="col-12 col--result" {...slideFadeInOut}>
                                    <div className="d-flex justify-content-between mb-2">
                                        <p className="text--16 font-weight-medium mb-0">{trans('app.header.search.pages')}</p>
                                        <a className="text--14 text-muted--60 text-base" href={resultsUrl} title={trans('app.header.search.show_amount_results', { amount: pages?.count })}>
                                            {trans('app.header.search.show_amount_results', { amount: pages?.count })}
                                        </a>
                                    </div>
                                    <AnimatePresence initial={false} exitBeforeEnter>
                                        {pages?.items?.map((page, pageIndex) => (
                                            <motion.a key={page?.id || pageIndex} className="text--14 text-base text-decoration-none text-truncate d-block" href={page.url} title={page.title} {...slideFadeInOut}>{page.title}</motion.a>
                                        ))}
                                    </AnimatePresence>
                                </motion.div>
                            )}
                        </AnimatePresence>
                        <AnimatePresence initial={false} exitBeforeEnter>
                            {actions?.count > 0 && (
                                <motion.div key="actions" className="col-12 col--result" {...slideFadeInOut}>
                                    <div className="d-flex justify-content-between mb-2">
                                        <p className="text--16 font-weight-medium mb-0">{trans('app.header.search.actions')}</p>
                                        <a className="text--14 text-muted--60 text-base" href={resultsUrl} title={trans('app.header.search.show_amount_results', { amount: actions?.count })}>
                                            {trans('app.header.search.show_amount_results', { amount: actions?.count })}
                                        </a>
                                    </div>
                                    <AnimatePresence initial={false} exitBeforeEnter>
                                        {actions?.items?.map((page, pageIndex) => (
                                            <motion.a key={page?.id || pageIndex} className="text--14 text-base text-decoration-none text-truncate d-block" href={page.url} title={page.title} {...slideFadeInOut}>{page.title}</motion.a>
                                        ))}
                                    </AnimatePresence>
                                </motion.div>
                            )}
                        </AnimatePresence>
                        <AnimatePresence initial={false} exitBeforeEnter>
                            {news?.count > 0 && (
                                <motion.div key="news" className="col-12 col--result" {...slideFadeInOut}>
                                    <div className="d-flex justify-content-between mb-2">
                                        <p className="text--16 font-weight-medium mb-0">{trans('app.header.search.news')}</p>
                                        <a className="text--14 text-muted--60 text-base" href={resultsUrl} title={trans('app.header.search.show_amount_results', { amount: news?.count })}>
                                            {trans('app.header.search.show_amount_results', { amount: news?.count })}
                                        </a>
                                    </div>
                                    <AnimatePresence initial={false} exitBeforeEnter>
                                        {news?.items?.map((page, pageIndex) => (
                                            <motion.a key={page?.id || pageIndex} className="text--14 text-base text-decoration-none text-truncate d-block" href={page.url} title={page.title} {...slideFadeInOut}>{page.title}</motion.a>
                                        ))}
                                    </AnimatePresence>
                                </motion.div>
                            )}
                        </AnimatePresence>
                    </div>
                    <Button
                        theme="primary"
                        title={trans('app.header.search.show_all_results')}
                        className="btn-block"
                        href={resultsUrl}
                    />
                </motion.div>
            )}
        </AnimatePresence>
    );
}
